<template lang="html">
  <div class="menusContainerMobileMenu">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuContainer'
}
</script>
